import clsx from 'clsx'
import React, {Dispatch, FC, SetStateAction, useEffect, useRef, useState} from 'react'
import {Modal} from 'react-bootstrap'
import TourStep1 from './components/step-one/TourStep1'
import TourStep1V2 from './components/step-one/TourStep1V2'
import PlatformConfiguration from './components/step-three/PlatformConfiguration'
import {useAppDispatch, useAppSelector} from 'src/redux/storeHooks'
import {fetchConnectedPlatformAsync, fetchPlatformsAsync} from 'src/redux/actions/platformActions'
import Loader from 'src/utils/Loader'
import { setInitialPopupDataAsync } from 'src/redux/actions/authActions'
import PopupPricing from './components/PopupPricing'
import ConfirmPlatformConnectionType from './components/ConfirmPlatformConnectionType'
import { setStepsData } from 'src/redux/slices/tourPopupSlice'
import { getUserPlanAsync } from 'src/redux/actions/pricingActions'
import {
  isDeferredFreeTrialOnboardingUser,
  mightNeedDeferredFreeTrialPlanCheck,
} from 'src/utils/freeTrialDeferredOnboarding'
import {
  fetchSkipSetupAsync,
  fetchUserAccountDetailsAsync,
  updatePlatformConnectionPriorityAsync,
} from 'src/redux/actions/accountActions'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { checkDynamicSettingPair } from 'src/utils/checkDynamicSettingPair'
import DynamicPlatformSettingNew from '../listing/DynamicPlatformSettingNew'
import AdvancedChannelSettingsPage from 'src/app/features/advanced-channel-settings/pages/AdvancedChannelSettingsPage'
import OmsChoiceModal from './components/OmsChoiceModal'
import TourStep2 from './components/step-two/TourStep2'
import {
  isConfirmPlatformConnectionSource,
  isPrimaryPlatform,
  isShopifyFamilyUserSource,
  resolvePrimaryPlatform,
} from './utils/tourPlatformSearch'

type StepStatus = 'active' | 'inactive' | 'finished'

type TourSteps = {
  // stepZero?:StepStatus
  stepOne: StepStatus
  stepTwo: StepStatus
  stepThree: StepStatus
}

type TourPopupPropsType = {
  // visible:boolean
  // loading:boolean
  // stepsData:TourSteps
  // selectedPlatformId:any
  // setStepsData: Dispatch<SetStateAction<TourSteps>>
  // setVisible: Dispatch<SetStateAction<boolean>>
  // setSelectedPlatformId: Dispatch<SetStateAction<string | undefined>>

}

// const TourPopupOms: FC<TourPopupPropsType> = ({loading,visible, stepsData, selectedPlatformId,setStepsData,setVisible,setSelectedPlatformId }) => {
  const TourPopupOms: FC<TourPopupPropsType> = () => {

  const [loading, setLoading] = useState(true)
  const { stepsData,visible } = useAppSelector(state=>state.tourPopup)
  const [searchParams] = useSearchParams()
  const useLegacySettingsOnboarding = [
    'legacy',
    'legacy_settings',
    'channel-settings-legacy',
  ].some((key) => {
    const value = searchParams.get(key)
    return value === '' || ['1', 'true', 'yes', 'on'].includes(`${value}`.toLowerCase())
  })
  const [selectedPlatformId, setSelectedPlatformId] = useState<string | undefined>(undefined)
  const [availablePlatformId, setAvailablePlatformId] = useState<string | undefined>(undefined)
  const [showDynamicPlatformSetting, setShowDynamicPlatformSetting] = useState<boolean | null>(null);
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const notOpenInPaths = ['/handle-app-installation','/handle-oauth-callback-restricted','/platform-setting','/primary-platform-setting','/platform-setting-new']
  const {fetchedUserAccountData } = useAppSelector(state=>state.userAccountData)
  const { userCurrentSubscription } = useAppSelector(state=>state.pricing)
  const {fetchedConnectedPlatformData, fetchedConnectedPlatformLoading, mainStoreData} = useAppSelector(
    (state) => state.fetchConnectedPlatform
  )
  const [confirmSkipOnboarding, setConfirmSkipOnboarding] = useState<boolean>(false)
  const [showOmsChoiceModal, setShowOmsChoiceModal] = useState(false)
  const [isSavingOmsPriority, setIsSavingOmsPriority] = useState(false)
  const modalRef = useRef<any>(null);

  
  const allowedSources = ['COMMERCIUM','WOOCOMMERCE','VEEQO','QBO','PRESTASHOP','DISCONNECT','BIGCOMMERCE','GOOGLE','ODOO','TIKTOK','VeeqoTT'];
  const confirmPlatformConnection = ['DISCONNECT', 'WIX', 'SHOPIFY', 'ECWID', 'BIGCOMMERCE']
  const localPlatformChoiceDone =
    fetchedUserAccountData?.id &&
    localStorage.getItem(`platform_choice_done_${fetchedUserAccountData.id}`) === 'true'
  const primaryConnectedPlatform = resolvePrimaryPlatform(
    fetchedConnectedPlatformData,
    mainStoreData
  )
  const isPrimaryStore = isPrimaryPlatform(primaryConnectedPlatform)
  const [autoSkipTriggered, setAutoSkipTriggered] = useState(false)
  const [isAutoSkipping, setIsAutoSkipping] = useState(false)
  const isForceOmsChoiceFromParam = ['1', 'true', 'yes'].includes(
    (new URLSearchParams(location.search).get('showOmsChoice') || '').toLowerCase()
  )
  const isTourPopupV2FromParam = ['1', 'true', 'yes'].includes(
    (new URLSearchParams(location.search).get('tourV2') || '').toLowerCase()
  )
  const buildTourLogContext = (extra: Record<string, any> = {}) => ({
    userId: fetchedUserAccountData?.id,
    source: fetchedUserAccountData?.source,
    isSubscribed: fetchedUserAccountData?.is_subscribed,
    isPhoneNumberStepDone: fetchedUserAccountData?.isPhoneNumberStepDone,
    isOnboardingProcessCompleted: fetchedUserAccountData?.isOnboardingProcessCompleted,
    isPlatformChoiceDone: fetchedUserAccountData?.is_platform_choice_done,
    connectedPlatforms: fetchedConnectedPlatformData?.length ?? 0,
    autoSkipTriggered,
    isAutoSkipping,
    path: window.location.pathname,
    ...extra,
  })

  const updateTourState = (stepData: TourSteps, visible: boolean, reason: string) => {
    console.debug('[TourPopup] visibility decision', reason, buildTourLogContext({ stepData, visible }))
    dispatch(setStepsData({stepData, visible}))
  }

  const handleAutoSkipSetup = async (reason: string) => {
    if (isAutoSkipping) {
      console.debug('[TourPopup] auto skip already running, skipping trigger', buildTourLogContext({ autoSkipReason: reason }))
      return
    }
    setIsAutoSkipping(true)
    console.debug('[TourPopup] auto skip start', buildTourLogContext({ autoSkipReason: reason, platformListStatus: 'empty' }))
    try {
      const skipResponse = await dispatch(fetchSkipSetupAsync())
      console.debug('[TourPopup] auto skip response', buildTourLogContext({ skipStatus: skipResponse?.payload?.status_code }))
      if (skipResponse?.payload?.status_code === 200) {
        await dispatch(fetchUserAccountDetailsAsync())
        navigate('/dashboard', {replace: true})
      }
    } catch (error) {
      console.error('[TourPopup] auto skip failed', error)
    } finally {
      setIsAutoSkipping(false)
    }
  }

  // const [visible, setVisible] = useState(false)
  // const [stepsData, setStepsData] = useState<TourSteps>({
  //   stepOne: 'active',
  //   stepTwo: 'inactive',
  //   stepThree: 'inactive',
  // })

  useEffect(() => {
    if((!notOpenInPaths.includes(window.location.pathname) && !notOpenInPaths.some(item=>(window.location.pathname.startsWith(item))) && fetchedUserAccountData) ){
      const isPricingPath =
        window.location.pathname === '/pricing' || window.location.pathname.startsWith('/pricing/')
      const localPlatformChoiceDone =
        fetchedUserAccountData?.id &&
        localStorage.getItem(`platform_choice_done_${fetchedUserAccountData.id}`) === 'true'

      if (!fetchedUserAccountData?.is_subscribed) {
        if (!isPricingPath) {
          navigate('/pricing', {replace: true})
        }
        updateTourState(stepsData, false, 'user not subscribed - hiding tour')
        setLoading(false)
        return
      }
      (async function () {
        try {
          let subscription = userCurrentSubscription
          if (mightNeedDeferredFreeTrialPlanCheck(fetchedUserAccountData) && !subscription) {
            const planRes = await dispatch(getUserPlanAsync())
            if (getUserPlanAsync.fulfilled.match(planRes) && planRes.payload?.data?.billing_plan) {
              subscription = planRes.payload.data
            }
          }
          const isDeferredFreeTrial = isDeferredFreeTrialOnboardingUser(
            fetchedUserAccountData,
            subscription
          )
          const autoOpenStep1TourIfAllowed = (stepData: TourSteps, reason: string) => {
            if (isDeferredFreeTrial) {
              return
            }
            updateTourState(stepData, true, reason)
          }

          await dispatch(fetchPlatformsAsync())
          const res = await dispatch(fetchConnectedPlatformAsync())
  
          if (res.payload?.status_code == 200) {
          const platformList = Array.isArray(res.payload?.data) ? res.payload?.data : []
          const platformCount = platformList.length
          const shouldAutoSkip =
            platformCount === 0 &&
            fetchedUserAccountData?.is_platform_choice_done &&
            !fetchedUserAccountData?.isOnboardingProcessCompleted

          if (shouldAutoSkip && !autoSkipTriggered) {
            setAutoSkipTriggered(true)
            await handleAutoSkipSetup('empty platform list but platform choice marked complete')
            setLoading(false)
            return
          }

          if (platformCount > 0 && platformCount <= 2) {
            setLoading(true)
            const isMainStoreCreated = platformList.find((item) => item?.isMainStore == true)
            const isAccountingStoreCreated = platformList.find((item) => item?.isAccountingStore == true)
            const isShippingStoreCreated = platformList.find((item) => item?.isShippingStore == true)
            const primaryStoreExists = Boolean(isMainStoreCreated || isAccountingStoreCreated || isShippingStoreCreated)
            const secondaryStore = platformList.find(
              (item) => !item?.isMainStore && !item?.isAccountingStore && !item?.isShippingStore
            )
            const hasSecondaryStore = Boolean(secondaryStore)
            const hasSecondaryOnly = hasSecondaryStore && !primaryStoreExists
            const hasPrimaryAndSecondary = primaryStoreExists && hasSecondaryStore

            //checking only main store created
            if (!primaryStoreExists && !hasSecondaryStore) {
              // setVisible(true)
              autoOpenStep1TourIfAllowed(
                stepsData,
                'no stores connected yet - show onboarding'
              )
              setLoading(false)

            }

            // TIKTOK (or any other) connected as secondary before primary
            if (hasSecondaryOnly) {
              updateTourState(
                {stepOne: 'finished', stepTwo: 'active', stepThree: 'inactive'},
                true,
                'secondary connected before primary - keep step2 active'
              )
              setSelectedPlatformId(secondaryStore?.id)
              setLoading(false)
            }

            //this if indicates that we have connected with a channel
            if (primaryStoreExists && !hasSecondaryStore) {
               const needsPlatformChoice =
                 isConfirmPlatformConnectionSource(
                 fetchedUserAccountData?.source,
                 confirmPlatformConnection
               ) &&
                 !fetchedUserAccountData?.is_platform_choice_done &&
                 !localPlatformChoiceDone
               if (needsPlatformChoice) {
                 autoOpenStep1TourIfAllowed(
                   {stepOne: 'active', stepTwo: 'inactive', stepThree: 'inactive'},
                   'platform choice required - step1 active'
                 )
                 setLoading(false)
                 return
               }

               if (
                 stepsData.stepOne === 'finished' &&
                 stepsData.stepTwo === 'active' &&
                 stepsData.stepThree !== 'active'
               ) {
                 if (!visible) {
                   updateTourState(stepsData, true, 'maintain step2 visibility on landing')
                 }
                 setLoading(false)
                 return
               }
               const isSourceSubscriptionAllowed =
                 ['DISCONNECT','GOOGLE'].includes(fetchedUserAccountData?.source!)
                   ? fetchedUserAccountData.is_subscribed
                   : true
               if( !isSourceSubscriptionAllowed && (!fetchedUserAccountData?.is_platform_choice_done && !localPlatformChoiceDone)  ){
                // if(!fetchedUserAccountData?.is_subscribed){
                //     navigate('/pricing')
                // }
                  if(window.location.pathname==='/pricing' || window.location.pathname.startsWith('/pricing/')){
                    if(fetchedUserAccountData.is_subscribed){
                      if (isShopifyFamilyUserSource(fetchedUserAccountData?.source)) {
                        updateTourState(
                          {stepOne: 'active', stepTwo: 'inactive', stepThree: 'inactive'},
                          false,
                          'pricing path + SHOPIFY source - keep tour hidden'
                        )
                      }
                      else if(/^\/pricing(\/.*)?$/.test(window.location.pathname) && fetchedUserAccountData?.source! === 'DISCONNECT') {
                        // Kept Empty for the Popup Validation
                      }
                      else{
                        autoOpenStep1TourIfAllowed(
                          {stepOne: 'active', stepTwo: 'inactive', stepThree: 'inactive'},
                          'pricing path + subscribed non-SHOPIFY - show step1'
                        )
                      }
                    }
                    else{
                      updateTourState(
                        {stepOne: 'active', stepTwo: 'inactive', stepThree: 'inactive'},
                        false,
                        'pricing path + not subscribed - hide tour'
                      )
                    }
                  }else{
                    autoOpenStep1TourIfAllowed(
                      {stepOne: 'active', stepTwo: 'inactive', stepThree: 'inactive'},
                      'non-pricing path + gating - show step1'
                    )
                  }
                  }else{
                    updateTourState(
                      {stepOne: 'finished', stepTwo: 'active', stepThree: 'inactive'},
                      true,
                      'subscription allowed - treat onboarding as step2'
                    )
                  }
                setLoading(false)
              }

              //we are checking that user has connected only one channel and changed the source type it means user has completed step 1
              if(fetchedUserAccountData.is_platform_choice_done && platformCount == 1 ){
                //now checking the source of user for other source
                const isSourceSubscriptionAllowed =
                  ['DISCONNECT','GOOGLE'].includes(fetchedUserAccountData?.source!)
                    ? fetchedUserAccountData.is_subscribed
                    : true
                if(!isSourceSubscriptionAllowed ){
                  updateTourState(
                    {stepOne: 'finished', stepTwo: 'active', stepThree: 'inactive'},
                    true,
                    'platform choice done + single platform + not subscribed source - show step2'
                  )
                }
              }
  
              //checking secondary store is also created but setting not configured
              if (hasPrimaryAndSecondary) {
                const secondaryStore = platformList.find((item) => (item?.isMainStore == false && item?.isAccountingStore == false && item?.isShippingStore == false))
                setSelectedPlatformId(secondaryStore?.id)
                updateTourState(
                  {stepOne: 'finished', stepTwo: 'finished', stepThree: 'active'},
                  true,
                  'primary+secondary connected - move to step3'
                )
                setLoading(false)
              }
            } else if (platformCount > 2) {
              updateTourState(stepsData, false, 'more than two platforms - close onboarding')
              setLoading(false)
              await dispatch(setInitialPopupDataAsync({isOnboardingProcessCompleted:true}))
            }else{
              if(window.location.pathname.includes('/pricing')){
                if(fetchedUserAccountData.is_subscribed){
                  autoOpenStep1TourIfAllowed(
                    stepsData,
                    'pricing path + subscribed - show tour fallback'
                  )
                }else{
                  updateTourState(stepsData, false, 'pricing path + not subscribed - hide tour')
                }
                setLoading(false)
                return
              }
              autoOpenStep1TourIfAllowed(stepsData, 'fallback: show tour for other paths')
              setLoading(false)
            }
          }
        } catch (error) {
          setLoading(false)
          updateTourState(stepsData, false, 'error fetching platforms - hide tour')
        }
      })();
    }else{
      // alert("your current path is ====> " + window.location.pathname)
      updateTourState(stepsData, false, 'path not eligible for tour - hide')
      // setVisible(false)
    }
  }, [
    window.location.pathname,
    fetchedUserAccountData?.id,
    fetchedUserAccountData?.is_platform_choice_done,
    fetchedUserAccountData?.is_subscribed,
    userCurrentSubscription,
  ])

 useEffect(() => {
  if (fetchedConnectedPlatformData?.length > 1) {
    const secondaryPlatform = fetchedConnectedPlatformData.find(item => (item?.isMainStore == false && item?.isAccountingStore == false && item?.isShippingStore == false));
    const mainStoreCode = [mainStoreData?.code ?? ''];
    const secondaryStoreCode = secondaryPlatform?.code;
    setAvailablePlatformId(secondaryPlatform?.platform_info?.id.toString())

    const showDynamic = checkDynamicSettingPair(mainStoreCode, secondaryStoreCode);
    setShowDynamicPlatformSetting(showDynamic);
    setLoading(false);
  }
  }, [fetchedConnectedPlatformData]);

  useEffect(() => {
    if (!visible || !fetchedUserAccountData?.id) {
      return
    }

    const seenKey = `onboarding_oms_choice_seen_${fetchedUserAccountData.id}`
    const hasSeenChoiceModal = sessionStorage.getItem(seenKey) === 'true'
    const shouldShowOmsChoiceModal = isForceOmsChoiceFromParam && !hasSeenChoiceModal

    if (shouldShowOmsChoiceModal) {
      setShowOmsChoiceModal(true)
    }
  }, [
    visible,
    fetchedUserAccountData?.id,
    isForceOmsChoiceFromParam,
  ])

  const markOmsChoiceAsSeen = () => {
    if (fetchedUserAccountData?.id) {
      sessionStorage.setItem(`onboarding_oms_choice_seen_${fetchedUserAccountData.id}`, 'true')
    }
  }

  const handleOmsChoiceContinue = () => {
    markOmsChoiceAsSeen()
    setShowOmsChoiceModal(false)
  }

  const handleOmsChoiceConnect = async () => {
    if (isSavingOmsPriority) {
      return
    }
    setIsSavingOmsPriority(true)
    markOmsChoiceAsSeen()
    try {
      await dispatch(
        updatePlatformConnectionPriorityAsync({platform_connection_priority: 'OMS'})
      )
      await dispatch(fetchUserAccountDetailsAsync())
    } finally {
      setIsSavingOmsPriority(false)
      setShowOmsChoiceModal(false)
      dispatch(setStepsData({stepData: stepsData, visible: false}))
      navigate('/listing-channels?connectAs=OMS&onboarding=1')
    }
  }

// Handle TikTok onboarding: when primary platform is connected after secondary (TikTok)
useEffect(() => {
  if (
    !fetchedConnectedPlatformLoading &&
    fetchedConnectedPlatformData?.length === 2 &&
    fetchedUserAccountData?.is_subscribed &&
    visible &&
    !notOpenInPaths.includes(window.location.pathname) &&
    !notOpenInPaths.some(item => window.location.pathname.startsWith(item))
  ) {
    const primaryStore = fetchedConnectedPlatformData.find(
      (item) => item?.isMainStore === true || item?.isAccountingStore === true || item?.isShippingStore === true
    );
    const secondaryStore = fetchedConnectedPlatformData.find(
      (item) => !item?.isMainStore && !item?.isAccountingStore && !item?.isShippingStore
    );

    // Only update if we have both primary and secondary, and we're in step 2 (secondary was connected first)
    if (primaryStore && secondaryStore && stepsData.stepTwo === 'active' && stepsData.stepOne === 'finished') {
      (async () => {
        try {
          setSelectedPlatformId(secondaryStore?.id?.toString())
          updateTourState(
            {stepOne: 'finished', stepTwo: 'finished', stepThree: 'active'},
            true,
            'primary+secondary in step2 - show step3'
          )
        } catch (error) {
          console.error('Error transitioning to step 3 after secondary connect:', error)
        }
      })()
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [fetchedConnectedPlatformData?.length, fetchedConnectedPlatformLoading, visible, stepsData.stepTwo, stepsData.stepOne]);
// Handle click outside modal
useEffect(() => {
  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setConfirmSkipOnboarding(true);
    }
  };
  
  document.addEventListener('mousedown', handleClickOutside);
  
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);

return (
  <Modal
    show={visible}
    scrollable
    size='xl'
    backdropClassName='bg-dark'
    className='mt-sm-0 mt-16 custmd'
  >
    {loading ? (
      <Loader variant="section" />
    ) : (
      <>
        {!showOmsChoiceModal ? (
        <Modal.Header className='p-0 m-0 border-0'>
          <div className='w-100 '>
            <div className='alert bg-light-primary d-flex flex-column flex-sm-row w-100 m-0'>
              <div className='d-flex align-items-sm-center w-100'>
                <div
                  className={clsx(
                    'd-flex align-items-center w-auto',
                    stepsData.stepThree === 'active' || stepsData.stepThree === 'finished'
                      ? 'text-success'
                      : stepsData.stepOne == 'active' || stepsData.stepTwo == 'active'
                      ? 'text-primary'
                      : ''
                  )}
                  style={{width: '15%'}}
                >
                  {stepsData.stepThree === 'active' || stepsData.stepThree === 'finished' ? (
                    <i
                      className={clsx('bi bi-check-circle-fill fs-2x')}
                      style={{color: '#07bc0c'}}
                    ></i>
                  ) : (
                    <i
                      className={clsx(
                        'bi bi-1-circle-fill fs-2x ',
                        stepsData.stepOne === 'active' || stepsData.stepTwo === 'active'
                          ? 'text-primary'
                          : 'text-secondary'
                      )}
                    ></i>
                  )}
                  <small className='fs-sm-6 fs-8 fw-bold lh-1 text-center'>Connect Channel</small>
                </div>

                <div className='separator w-25 border-2 border-light-secondary me-5 d-sm-block d-none'></div>
                <div
                  className={clsx(
                    'd-flex align-items-center w-auto',
                    stepsData.stepThree == 'active'
                      ? 'text-primary'
                      : stepsData.stepThree == 'finished'
                      ? 'text-success'
                      : 'text-secondary'
                  )}
                  style={{width: '15%'}}
                >
                  {stepsData.stepThree == 'finished' ? (
                    <i
                      className={clsx('bi bi-check-circle-fill fs-2x me-2')}
                      style={{color: '#07bc0c'}}
                    ></i>
                  ) : (
                    <i
                      className={clsx(
                        'bi bi-2-circle-fill fs-2x me-2',
                        stepsData.stepThree == 'inactive'
                          ? 'text-muted'
                          : stepsData.stepThree === 'active'
                          ? 'text-primary'
                          : 'text-secondary'
                      )}
                    ></i>
                  )}
                  <small className='fs-sm-6 fs-8 fw-bold lh-1 text-center'>Complete Settings</small>
                </div>
              </div>
            </div>
          </div>
        </Modal.Header>
        ) : null}
        <Modal.Body>
          {/* { ['SHOPIFY', 'WOOCOMMERCE','ECWID' ].includes(fetchedUserAccountData?.source!) && 
              !userCurrentSubscription?.current_billing_plan && stepsData?.stepZero === 'active' ? (
                <PopupPricing 
                  setStepsData={setStepsData}
                />
              ) : null} */}
          {showOmsChoiceModal ? (
            <OmsChoiceModal
              onConnectAsOms={handleOmsChoiceConnect}
              onContinue={handleOmsChoiceContinue}
              isOmsContinueLoading={isSavingOmsPriority}
            />
          ) : (
            <>
              {allowedSources.includes(fetchedUserAccountData?.source!) &&
              stepsData.stepOne === 'active' &&
              (fetchedUserAccountData?.source === 'GOOGLE'
                ? fetchedUserAccountData?.is_subscribed
                : !isConfirmPlatformConnectionSource(
                 fetchedUserAccountData?.source,
                 confirmPlatformConnection
               )) ? (
                isTourPopupV2FromParam ? (
                  <TourStep1V2
                    mergedMode={true}
                    setSelectedPlatformId={setSelectedPlatformId}
                    confirmSkipOnboarding={confirmSkipOnboarding}
                    setConfirmSkipOnboarding={setConfirmSkipOnboarding}
                  />
                ) : (
                  <TourStep1
                    setSelectedPlatformId={setSelectedPlatformId}
                    confirmSkipOnboarding={confirmSkipOnboarding}
                    setConfirmSkipOnboarding={setConfirmSkipOnboarding}
                  />
                )
              ) : null}
              {/* Fallback: for sources not in allowedSources (and not in confirm list) still show normal flow */}
              {!allowedSources.includes(fetchedUserAccountData?.source!) &&
              stepsData.stepOne === 'active' &&
              !isConfirmPlatformConnectionSource(
                 fetchedUserAccountData?.source,
                 confirmPlatformConnection
               ) &&
              // Keep the same subscription guard used for allowed sources (e.g., block unsubscribed GOOGLE/DISCONNECT)
              (fetchedUserAccountData?.source === 'GOOGLE'
                ? fetchedUserAccountData?.is_subscribed
                : !['DISCONNECT'].includes(fetchedUserAccountData?.source!)) ? (
                isTourPopupV2FromParam ? (
                  <TourStep1V2
                    mergedMode={true}
                    setSelectedPlatformId={setSelectedPlatformId}
                    confirmSkipOnboarding={confirmSkipOnboarding}
                    setConfirmSkipOnboarding={setConfirmSkipOnboarding}
                  />
                ) : (
                  <TourStep1
                    setSelectedPlatformId={setSelectedPlatformId}
                    confirmSkipOnboarding={confirmSkipOnboarding}
                    setConfirmSkipOnboarding={setConfirmSkipOnboarding}
                  />
                )
              ) : null}

              {stepsData.stepTwo === 'active' ? (
                isPrimaryStore ? (
                  <TourStep2 setSelectedPlatformId={setSelectedPlatformId} />
                ) : isTourPopupV2FromParam ? (
                  <TourStep1V2
                    mergedMode={true}
                    setSelectedPlatformId={setSelectedPlatformId}
                    confirmSkipOnboarding={confirmSkipOnboarding}
                    setConfirmSkipOnboarding={setConfirmSkipOnboarding}
                  />
                ) : (
                  <TourStep1
                    setSelectedPlatformId={setSelectedPlatformId}
                    confirmSkipOnboarding={confirmSkipOnboarding}
                    setConfirmSkipOnboarding={setConfirmSkipOnboarding}
                  />
                )
              ) : null}

              {(isConfirmPlatformConnectionSource(
                 fetchedUserAccountData?.source,
                 confirmPlatformConnection
               )
                ? fetchedUserAccountData?.is_subscribed
                : false) &&
              stepsData.stepOne === 'active' &&
              !fetchedUserAccountData?.is_platform_choice_done &&
              !localPlatformChoiceDone ? (
                <ConfirmPlatformConnectionType />
              ) : null}

              {fetchedConnectedPlatformData?.length > 1 &&
              showDynamicPlatformSetting === false &&
              stepsData.stepThree === 'active' ? (
                <PlatformConfiguration
                  selectedPlatformId={selectedPlatformId}
                  afterSettingCB={async () => {
                    dispatch(
                      setStepsData({
                        stepData: {stepOne: 'finished', stepTwo: 'finished', stepThree: 'finished'},
                        visible: false,
                      })
                    )
                    await dispatch(fetchUserAccountDetailsAsync())
                  }}
                />
              ) : null}

              {/* // Show Dynamic Platform Setting*/}
              {showDynamicPlatformSetting === true &&
              stepsData.stepThree === 'active' &&
              selectedPlatformId &&
              availablePlatformId ? (
                useLegacySettingsOnboarding ? (
                  <DynamicPlatformSettingNew
                    isFromOnboarding={true}
                    selectedPlatformId={selectedPlatformId}
                    availablePlatformId={availablePlatformId}
                    afterSettingCB={async () => {
                      dispatch(
                        setStepsData({
                          stepData: {stepOne: 'finished', stepTwo: 'finished', stepThree: 'finished'},
                          visible: false,
                        })
                      )
                      await dispatch(fetchUserAccountDetailsAsync())
                    }}
                  />
                ) : (
                  <AdvancedChannelSettingsPage
                    isFromOnboarding={true}
                    selectedPlatformId={selectedPlatformId}
                    availablePlatformId={availablePlatformId}
                    afterSettingCB={async () => {
                      dispatch(
                        setStepsData({
                          stepData: {stepOne: 'finished', stepTwo: 'finished', stepThree: 'finished'},
                          visible: false,
                        })
                      )
                      await dispatch(fetchUserAccountDetailsAsync())
                    }}
                  />
                )
              ) : null}
            </>
          )}
          <section></section>
        </Modal.Body>
      </>
    )}
  </Modal>
)
}

export default TourPopupOms
